import React from 'react'
import "../assests/about.css"

function About({style}) {
  return (
    <div>
      <div className={style}></div>
      <div className="about">
        <h1>
        What is {" "}
        <span style={{color:"#32BAC7"}}>
           SGC?
        </span>
        </h1>
      </div>
      <div className="about-details">
        Student Guidance Cell (SGC) aims to provide guidance and counselling services to students based on their needs with assured privacy and confidential exchange of communication. SGC also provides academic support in the form of special classes for students. The formation of SGC was based on the feedback from graduated students of the institute who stressed on the need to have a facility to counsel and motivate the students. SGC helps the students to function better in all domains of life - academic, social, personal and psychological. 
        <br/>
        <div style={{height:"20px",width:"100%"}}></div>
        The motive behind SGC stems from the need to facilitate the process of growth and maintain a positive well being of the students. The counselling services offered by SGC empowers the students to have enhanced ability to solve problems, make decisions as well as make them more efficient in tackling personal problems. In a nut shell, it is aimed at enhancing their ability to utilise the best potential available in them. 
        <br/>
        <div style={{height:"20px",width:"100%"}}></div>
        The SGC avails the help of two trained clinical psychologists who are available in the institute.
      </div>
    </div>
  )
}

export default About